/* eslint-disable */
import beforeEach from "@/router/beforeEach.js";
import EventLogsAll from "@/views/EventLogs/All.vue";
import EventLogsFailed from "@/views/EventLogs/Failed.vue";
import EventLogsLayout from "@/views/EventLogs/Layout.vue";
import EventLogsSuccess from "@/views/EventLogs/Success.vue";
import FourZeroFour from "@/views/FourZeroFour.vue";
import Home from "@/views/Home.vue";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
	    // public routes from campaign viewers
	    {
			path: "/campaigns/:campaignId",
			component: () => import("@/views/Campaign.vue"),
			meta: {
				title: "View Campaign in Browser"
			}
		},
	    // Admin Panel Routes
	    {
	    	path: "/",
	    	redirect: "/admin"
	    },
		{
			path: "/admin",
			name: "admin.dashboard",
			component: Home,
			meta: {
				title: "Dashboard",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_developer', 'wemail_analyst' ]
			}
		},
		{
			path: "/admin/campaigns",
			name: "Campaigns",
			component: () => import("@/views/Campaigns/Index.vue"),
			meta: {
				title: "Campaigns",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/coupons",
			name: "Coupons",
			component: () => import("@/views/Coupons/Index.vue"),
			meta: {
				title: "Coupons",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/notice-boards",
			name: "Notice Boards",
			component: () => import("@/views/NoticeBoards/Index.vue"),
			meta: {
				title: "Notice Boards",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/users",
			name: "users",
			component: () => import("@/views/users/index.vue"),
			meta: {
				title: "Users",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/site-users",
			name: "site-users",
			component: () => import("@/views/users/SiteUsers/Index.vue"),
			meta: {
				title: "Site Users",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/site-users/:userId",
			name: "site-user",
			component: () => import("@/views/users/SiteUsers/Details.vue"),
			meta: {
				title: "Site User",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites",
			name: "sites.index",
			component: () => import("@/views/sites/Index.vue"),
			meta: {
				title: "Sites",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/top",
			name: "sites.top.index",
			component: () => import("@/views/sites/TopSitesIndex.vue"),
			meta: {
				title: "Top Sites",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/paid",
			name: "sites.paid.index",
			component: () => import("@/views/sites/PaidSitesIndex.vue"),
			meta: {
				title: "Premium Sites",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/deletion-request",
			name: "sites.data.deletion",
			component: () => import("@/views/sites/DataDeletion.vue"),
			meta: {
				title: "Deletion Request",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/search-site",
			name: "sites.search-site",
			component: () => import("@/views/sites/SearchSite.vue"),
			meta: {
				title: "Find Site",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/:siteId/lists/:listId/subscribers",
			name: "sites.lists.subscribers",
			component: () => import("@/views/sites/ListSubscribers.vue"),
			meta: {
				title: "Lists Subscribers",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/sites/:siteId/",
			name: "sites.layout",
			component: () => import("@/views/sites/Layout.vue"),
			meta: {
				title: "Sites Overview",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			},
			children: [
				{
					path: "",
					name: "sites.overview",
					component: () => import("@/views/sites/Overview.vue"),
					meta: {
						title: "Sites Overview",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "campaigns",
					name: "sites.campaigns",
					component: () => import("@/views/sites/Campaigns.vue"),
					meta: {
						title: "Site Campaigns",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "campaigns/:campaignId",
					name: "sites.campaign.overview",
					component: () => import("@/views/sites/CampaignOverview.vue"),
					meta: {
						title: "Campaign Overview",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "lists",
					name: "sites.lists",
					component: () => import("@/views/sites/Lists.vue"),
					meta: {
						title: "Site Lists",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "logs",
					name: "sites.logs",
					component: () => import("@/views/sites/Logs.vue"),
					meta: {
						title: "Site Logs",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "settings",
					name: "sites.settings",
					component: () => import("@/views/sites/Settings.vue"),
					meta: {
						title: "Site Settings",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "subscription",
					name: "sites.subscription",
					component: () => import("@/views/sites/Subscription.vue"),
					meta: {
						title: "Site Subscription",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "team",
					name: "sites.team",
					component: () => import("@/views/sites/Team.vue"),
					meta: {
						title: "Site Team",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				},
				{
					path: "health",
					name: "sites.health",
					component: () => import("@/views/sites/Health.vue"),
					meta: {
						title: "Site Health Status",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin' ]
					}
				}
			]
		},
		{
			path: "/admin/servers",
			name: "servers",
			component: () => import("@/views/Servers.vue"),
			meta: {
				title: "Servers",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/servers/:key/:server",
			name: "serverdetails",
			component: () => import("@/views/ServerDetails.vue"),
			meta: {
				title: "Server Details",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin' ]
			}
		},
		{
			path: "/admin/event-logs",
			name: "eventlogs",
			component: EventLogsLayout,
			meta: {
				title: "Events & Logs",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_developer' ]
			},
			children: [
				{
					path: "",
					name: "eventlogs.overview",
					redirect: { name: 'eventlogs.all' }
				},
				{
					path: "all",
					name: "eventlogs.all",
					component: EventLogsAll,
					meta: {
						title: "All Events & Logs",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin', 'wemail_developer' ]
					}
				},
				{
					path: "success",
					name: "eventlogs.success",
					component: EventLogsSuccess,
					meta: {
						title: "Success Events & Logs",
						requiresAuth: true,
						authorizationFor: [ 'wemail_admin', 'wemail_developer' ]
					}
				},
				{
					path: "failed",
					name: "eventlogs.failed",
					component: EventLogsFailed,
					meta: {
		            	title: "Failed Events & Logs",
		            	requiresAuth: true,
		            	authorizationFor: [ 'wemail_admin', 'wemail_developer' ]
		            }
				}
			]
		},

		{
			path: "/admin/stats",
			name: "stats",
			component: () => import("@/views/Stats/Overview.vue"),
			meta: {
				title: "Stats",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_analyst' ]
			}
		},
		{
			path: "/admin/stats/open-click-bounce",
			name: "stats.open.click.bounce",
			component: () => import("@/views/Stats/OpenClickBounce.vue"),
			meta: {
				title: "Open VS Click VS Bounce",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_analyst' ]
			}
		},
		{
			path: "/admin/stats/subscribe-unsubscribe",
			name: "stats.subscribe.unsubscribe",
			component: () => import("@/views/Stats/SubscribeUnsubscribe.vue"),
			meta: {
				title: "Subscribe VS Unsubscribe",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_analyst' ]
			}
		},
		{
			path: "/admin/subscription-calcels",
			name: "subscription.calcels",
			component: () => import("@/views/Subscriptions/CancelsReasons.vue"),
			meta: {
				title: 'Subscription cancels',
				requiresAuth: true,
			}
		},

		// Authentication Routes
		{
			path: "/login",
			name: "login",
			component: () => import("@/views/Auth/Login.vue"),
			meta: {
				title: "Login"
			}
		},
		{
			path: "/password/forget",
			name: "password.forget",
			component: () => import("@/views/Auth/ForgotPassword.vue"),
			meta: {
				title: "Forget Password"
			}
		},
		{
			path: "/password/reset",
			name: "password.reset",
			component: () => import("@/views/Auth/ResetPassword.vue"),
			meta: {
				title: "Reset Password"
			}
		},
		{
			path: "/change-password",
			name: "password.change",
			component: () => import("@/views/Profile/ChangePassword.vue"),
			meta: {
				title: "Change Password",
				requiresAuth: true,
				authorizationFor: [ 'wemail_admin', 'wemail_developer', 'wemail_analyst' ]
			}
		},
		/**
		 * Not Found
		 */
		{
		    path: '*',
		    component: FourZeroFour,
		    meta: {
		    	title: '404 - Not Found'
		    }
		}
	]
});

router.beforeEach(beforeEach);

export default router;
